import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "./calendar.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import apiServiceHandler from "../../service/apiService";
import AddEventModal from "./addEventModal";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import ViewEventModal from "./viewEventModal";
import NoAccessModal from "./../Content-Library/NoAccessModal"

const localizer = momentLocalizer(moment);

const MyCalendar = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  const isAdmin = userDetails?.admin

  const [events, setEvents] = useState([]);
  const [eventAddModal, setEventAddModal] = useState(false)
  const [eventViewModal, setEventViewModal] = useState(false)
  const [refreshEventData, setRefreshEventData] = useState(false);
  const [viewData, setViewData] = useState({});
  const [currentDate, setCurrentDate] = useState(new Date());
  const [noAccessModal, setNoAccessModal] = useState(false);
  const [currentView, setCurrentView] = useState(Views.MONTH);

  const toggleAddEventModal = () => {
    if (userDetails.admin) {
      setRefreshEventData(true);
      setEventAddModal(!eventAddModal)
    }
    else
      toastr.error('Only admin can add events!')
  }

  const toggleNoAccessModal = () => {
    setNoAccessModal(!noAccessModal);
  }

  const toggleViewEventModal = (event) => {
    if (userDetails.courses_access[event.group_code] != 1) {
      toggleNoAccessModal();
      console.error('You do not have access to this event!')
    } else {
      setViewData(event);
      setEventViewModal(!eventViewModal)
    }
  }

  const getAllEvents = async () => {
    try {
      const response = await apiServiceHandler(
        "GET",
        `api/calendar/events?month=${currentDate.getMonth()}&year=${currentDate.getFullYear()}`,
        {}
      );
      if (response.auth) {
        setEvents(response.data);
      }
    } catch (error) {
      console.log("Something went wrong! ", error);
    }
  };

  useEffect(() => {
    getAllEvents();
    setRefreshEventData(false);
  }, [refreshEventData, currentDate]);

  const CustomEvent = ({ event }) => {
    const startTime = moment(event.start).format("hh:mm A");
    return (
      <div className="custom-event">
        <span className="event-title"><strong>{startTime}</strong>: {event.title}</span>
      </div>
    );
  };

  const CustomToolbar = (toolbarProps) => {
    return (
      <div className="rbc-toolbar">
        <div className="toolbar-left">
          <button onClick={() => toolbarProps.onNavigate('PREV')}>Previous</button>
          <button onClick={() => toolbarProps.onNavigate('NEXT')}>Next</button>
        </div>
        <span className="toolbar-center">{toolbarProps.label}</span>
        <div className="toolbar-right">
          {isAdmin && <button className="add-event-btn" onClick={toggleAddEventModal}>Add Event</button>}
          <button onClick={() => toolbarProps.onView(Views.MONTH)}>Month</button>
          <button onClick={() => toolbarProps.onView(Views.WEEK)}>Week</button>
          <button onClick={() => toolbarProps.onView(Views.DAY)}>Day</button>
          <button onClick={() => toolbarProps.onView(Views.AGENDA)}>Agenda</button>
        </div>
      </div>
    );
  };

  const getComponentsForView = (view) => {
    if (view === Views.MONTH) {
      return { toolbar: CustomToolbar, event: CustomEvent };
    }
    return { toolbar: CustomToolbar };
  };

  return (
    <div className="calendar">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor={(event) => { return new Date(event.start) }}
        endAccessor={(event) => { return new Date(event.end) }}
        selectable
        onSelectEvent={toggleViewEventModal}
        onSelectSlot={toggleAddEventModal}
        date={currentDate}
        onNavigate={(date) => setCurrentDate(date)}
        onView={(view) => setCurrentView(view)}
        components={getComponentsForView(currentView)}
        style={{ height: "100%", width: "100%" }}
      />
      <AddEventModal isOpen={eventAddModal} onClose={toggleAddEventModal} setRefreshEventData={setRefreshEventData} />
      <ViewEventModal isOpen={eventViewModal} onClose={() => setEventViewModal(!eventViewModal)} data={viewData} setRefreshEventData={setRefreshEventData} />
      <NoAccessModal isOpen={noAccessModal} onClose={toggleNoAccessModal} />
    </div>
  );
};

export default MyCalendar;
